import type { BadgeProps } from '@/components/ui/Badge'
import type { StaffStatus } from './types'

export const staffStatusTone: Record<StaffStatus, NonNullable<BadgeProps['tone']>> = {
  active: 'success',
  on_leave: 'warning',
  resigned: 'neutral',
  terminated: 'danger',
}
